module.exports = __webpack_public_path__ + "img/del.093b2797.png";